export default __webpack_public_path__ + "7cc2944f187ea510b4c738969381afae.ttf";